//引入api接口
import { fun_PostAction, fun_Download } from "@/api/index";
import { fun_DownloadFile } from "@/utils/validate.js";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 项目一览loading状态
      loading: false,
      // 表单字段
      form: {
        tenderMakeId: null, // 招标编号
        projectName: null, // 项目名称
        prequalificationType: null, // 资格审查方式
        fileTemplateId: null, // 采购文件模板主键
        bidType: null, // 示范文本类型
        tenderName: null // 招标人
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "标书文件制作表主键：",
          value: "id",
          placeholder: "请输入",
          clearable: true,
          width: 180
        },
        {
          type: "input",
          label: "项目名称：",
          value: "projectName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "slot",
          label: "评标办法：",
          slotName: "evaluationMethod"
        },
        {
          type: "slot",
          label: "评审办法：",
          slotName: "prequalificationMethod"
        },
        {
          type: "select",
          label: "资格审查方式：",
          value: "prequalificationType",
          queryParams: {
            sqlId: "13f3e366-dbb0-4ea2-a6bf-6b84339ab42c",
            dictionaryId: "1544305943211057152"
          }
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          slotName: "projectName",
          width: 480,
          fixed: true
        },
        {
          label: "标段名称",
          prop: "sectionName",
          width: 130
        },
        {
          label: "资格审查方式",
          prop: "prequalificationTypeName",
          align: "center",
          width: 130
        },
        {
          label: "项目编号",
          prop: "projectId",
          width: 200
        },
        {
          label: "登记编号",
          prop: "regCode",
          width: 200
        },
        {
          label: "标书文件制作表主键",
          prop: "id",
          width: 180
        },
        {
          label: "评标办法",
          prop: "typeName",
          width: 470
        },
        {
          label: "招标人",
          prop: "tenderName",
          width: 180
        },
        {
          label: "招标代理机构",
          prop: "tenderAgentOrgan",
          width: 180
        },
        {
          label: "操作",
          slotName: "op",
          width: 100,
          align: "center",
          fixed: "right"
        }
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 数据字典总条数
      evaluationMethod: [], // 评标办法
      prequalificationMethod: [], // 资格预审办法
      fileTemplateId1: null, // 评标办法下拉框绑定值
      fileTemplateId2: null, // 评审办法下拉框绑定值
      filePath: null, // 文件路径
      fullscreenLoading: false // 全屏loading
    };
  },

  // 模板编译完成
  mounted() {
    // 执行列表列表获取方法
    this.fun_GetList();
    // 获取评标办法下拉框
    this.fun_GetEvaluationMethod();
    // 获取评审办法下拉框
    this.fun_GetPrequalificationMethod();
  },

  // 自定义方法
  methods: {
    /**
     * 获取项目信息一览
     * @author shuhua
     */
    fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 执行获取列表接口
        fun_PostAction("/riskReissue/list", {
          ...this.form,
          ...this.reqPageData
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 解析后台返回的结果集，判断是否成功
          if (result) {
            // 成功的场景
            // 将请求到的table数据渲染到table
            this.tableData = data.records;
            // 展示分页总条数
            this.total = data.total;
          } else {
            // 请求失败的场景
            // 请求失败，弹出失败msg的消息提示
            this.$message.error(msg);
          }
          // 关闭loading
          this.loading = false;
        });
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 获取评标办法下拉框
     * @author shuhua
     */
    fun_GetEvaluationMethod() {
      // 请求，获取结果集
      fun_PostAction("/bidEvaluationReport/getBidEvaluationMethod", {
        bidType: "tenderFile"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 评标办法下拉框
          this.evaluationMethod = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取评标办法下拉框
     * @author shuhua
     */
    fun_GetPrequalificationMethod() {
      // 请求，获取结果集
      fun_PostAction("/bidEvaluationReport/getBidEvaluationMethod", {
        bidType: "evaluationFile"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 评标办法下拉框
          this.prequalificationMethod = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * @description 资格审查方式下拉框
     * @param {e} 选中的value值
     * @author 滕威
     */
    fun_GetSelectVal(event, value) {
      // 资格审查方式
      if (value === "prequalificationType") {
        // 资格审查方式
        this.form.prequalificationType = event;
      } else {
        // 采购文件模板主键
        this.form.fileTemplateId = event;
        // 示范文本类型
        this.form.bidType = value;
      }
    },
    /**
     * 批量补发
     * @author shuhua
     */
    fun_Reissue() {
      // 打开加载
      this.loading = true;
      // 请求
      fun_PostAction("/riskReissue/reissue", {
        tenderMakeId: this.form.id
      }).then(res => {
        // 解构 res.data
        const { result, msg } = res.data;
        // 操作成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
        } else {
          // 操作失败
          this.$message.error(msg);
        }
      });
      // 关闭加载
      this.loading = false;
    },
    /**
     * 补发
     * @author shuhua
     */
    fun_RiskReissue(e) {
      // 打开加载
      this.loading = true;
      // 请求
      fun_PostAction("/riskReissue/reissue", {
        tenderMakeId: e.id
      }).then(res => {
        // 解构 res.data
        const { result, msg } = res.data;
        // 操作成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
        } else {
          // 操作失败
          this.$message.error(msg);
        }
      });
      // 关闭加载
      this.loading = false;
    },
    /**
     * 数据字典改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 数据字典改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 数据字典查询
     * @author 滕威
     */
    fun_Search() {
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    }
  }
};
